module.exports = __webpack_public_path__ + "img/xkool-icon-logo.e62ef535.png";